import React, {Component} from "react"

import {IndexRedirect, NestedRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import {HasPermissionTo} from "@irati/utils/permissions"
import {LangLoader} from "@irati/utils/lang"

import LandingScreen from "../containers/LandingScreen"

interface Props {
  path: string
}

const payrollPayStoreLangBucket = "payrollPayStore"

export default class PayrollPayStoreRoutes extends Component<Props> {
  // TODO: review permission check
  render() {
    const {path} = this.props
    return (
      <AppContainer>
        <HasPermissionTo permissions="benefits">
          <LangLoader buckets={[payrollPayStoreLangBucket]}>
            <NestedRoute useGrid={false} match={path} path={"/landing"} title="Test" component={LandingScreen} />
            <IndexRedirect match={{url: path}} to="/landing" />
          </LangLoader>
        </HasPermissionTo>
      </AppContainer>
    )
  }
}
